import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { listarNotificacoes, marcarNotificacaoLida, marcarTodasNotificacoesLidas } from "../services/api";

export default function NotificationBell() {
  const navigate = useNavigate();
  const [itens, setItens] = useState([]);
  const [aberto, setAberto] = useState(false);

  const carregar = useCallback(async () => {
    try { setItens(await listarNotificacoes()); } catch { /* sem login ou offline */ }
  }, []);

  useEffect(() => {
    carregar();
    const t = setInterval(carregar, 30000); // poll a cada 30s
    return () => clearInterval(t);
  }, [carregar]);

  const naoLidas = itens.filter((n) => !n.lida).length;

  const marcar = async (n) => {
    if (!n.lida) { try { await marcarNotificacaoLida(n.id); carregar(); } catch {} }
    // Notificação com link → navega (ex.: alerta de prazo abre o painel apontando pro relato).
    if (n.link) { setAberto(false); navigate(n.link); }
  };

  const marcarTodas = async () => {
    try { await marcarTodasNotificacoesLidas(); carregar(); } catch {}
  };

  return (
    <div className="relative">
      <button
        onClick={() => setAberto((v) => !v)}
        className="relative inline-flex h-9 w-9 items-center justify-center rounded-full hover:bg-white/15"
        aria-label={naoLidas > 0 ? `Notificações (${naoLidas} não lidas)` : "Notificações"}
        aria-haspopup="true"
        aria-expanded={aberto}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M13.7 21a2 2 0 01-3.4 0" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        {naoLidas > 0 && (
          <span className="absolute -top-0.5 -right-0.5 h-4 min-w-4 px-1 rounded-full bg-orange-500 text-[10px] font-bold flex items-center justify-center">
            {naoLidas}
          </span>
        )}
      </button>

      {aberto && (
        <div className="absolute right-0 mt-2 w-80 max-h-96 overflow-auto rounded-xl bg-white text-gray-800 shadow-xl border border-gray-200 z-50">
          <div className="px-4 py-3 border-b flex items-center justify-between gap-2">
            <span className="font-semibold text-sm">Notificações</span>
            {naoLidas > 0 && (
              <button onClick={marcarTodas} className="text-xs text-primary font-semibold hover:underline">Marcar todas como lidas</button>
            )}
          </div>
          {itens.length === 0 ? (
            <div className="px-4 py-6 text-sm text-gray-500 text-center">Sem notificações.</div>
          ) : (
            itens.map((n) => (
              <button
                key={n.id}
                onClick={() => marcar(n)}
                className={`block w-full text-left px-4 py-3 border-b last:border-0 hover:bg-gray-50 ${n.lida ? "opacity-60" : ""}`}
              >
                <div className="flex items-start gap-2">
                  {!n.lida && <span className="mt-1.5 h-2 w-2 rounded-full bg-orange-500 shrink-0" />}
                  <div>
                    <p className="text-sm">{n.texto}</p>
                    <p className="text-xs text-gray-400 mt-0.5">{new Date(n.criadoEm).toLocaleString("pt-BR")}</p>
                  </div>
                </div>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
